import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="relative flex h-auto min-h-screen w-full flex-col bg-[#131118] dark group/design-root overflow-x-hidden"
         style={{ fontFamily: '"Space Grotesk", "Noto Sans", sans-serif' }}>
      <div className="layout-container flex h-full grow flex-col">
        <header className="flex items-center justify-between whitespace-nowrap border-b border-solid border-b-[#2e2839] px-10 py-3">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-4 text-white">
              <div className="h-8 w-auto">
                <img 
                  src="/byteplus.png" 
                  alt="BytePlus" 
                  className="h-full w-auto"
                />
              </div>
              <h2 className="text-white text-lg font-bold leading-tight tracking-[-0.015em]">BytePlus AI</h2>
            </div>
            <div className="flex items-center gap-9">
              {/* <Link 
                className={`text-sm font-medium leading-normal ${isActive('/') ? 'text-[#5b13ec]' : 'text-white hover:text-[#5b13ec]'}`} 
                to="/"
              >
                Home
              </Link>
              <Link 
                className={`text-sm font-medium leading-normal ${isActive('/generate') ? 'text-[#5b13ec]' : 'text-white hover:text-[#5b13ec]'}`} 
                to="/generate"
              >
                Generate Images
              </Link>
              <Link 
                className={`text-sm font-medium leading-normal ${isActive('/video') ? 'text-[#5b13ec]' : 'text-white hover:text-[#5b13ec]'}`} 
                to="/video"
              >
                Generate Video
              </Link> */}
              {/* === MENU BARU DITAMBAHKAN DI SINI === */}
              <Link 
                className={`text-sm font-medium leading-normal ${isActive('/vod') ? 'text-[#5b13ec]' : 'text-white hover:text-[#5b13ec]'}`} 
                to="/vod"
              >
                AI Studios
              </Link>
            </div>
          </div>
          {/* <div className="flex flex-1 justify-end gap-8">
            <div className="flex items-center gap-3">
              <a
                href="https://bytedance.sg.larkoffice.com/share/base/form/shrlgPbkP3MgkxQuO82LoB4fBsg"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center h-10 px-6 bg-[#2e2839] hover:bg-[#3a3145] text-white rounded-xl text-sm font-semibold leading-normal tracking-[0.015em] transition-colors duration-200 whitespace-nowrap border border-[#5b13ec]"
              >
                Submit your art
              </a>
              <a
                href="https://www.byteplus.com/en/go/accelerate-your-ai-journey?utm_source=conference&utm_medium=branding&utm_campaign=BP-MYID-IGDX2025-Q4-FY25&utm_term=mkt_myid&utm_content=modelark"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center h-10 px-6 bg-[#5b13ec] hover:bg-[#4a0fc7] text-white rounded-xl text-sm font-semibold leading-normal tracking-[0.015em] transition-colors duration-200 whitespace-nowrap"
              >
                Book a Demo
              </a>
            </div>
            <button
              className="flex max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-xl h-10 bg-[#2e2839] text-white gap-2 text-sm font-bold leading-normal tracking-[0.015em] min-w-0 px-2.5"
            >
              <div className="text-white" data-icon="Question" data-size="20px" data-weight="regular">
                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" viewBox="0 0 256 256">
                  <path
                    d="M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"
                  />
                </svg>
              </div>
            </button>
            <div
              className="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10"
              style={{
                backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuD4SVTQlC2P7M5cIIF2u20FLkqSzGNrLLFFpWQeJUzM2WNSL1E2Uf8HcgSHWgdYPPCjxfVERi5zaXss02-M0_hRoS1pOpB1JR8mTkYS7BF4rbD6ZABpUwg4SW3ds7bmIgZL4R8wh6uS7fkmAcMacWRGIhsnmacPVlzaYZhkOx-EgOiDNFO_c73Ob8ti34p_uEl2lG76uGrxKBC53tWs2c2LaNr__NIB0jkspO-QDtMIfPFqaVerxxZmZgTBHZoGMhYFTbHjTennBss")'
              }}
            />
          </div> */}
        </header>
        <main className="flex-1">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
